import _cloneDeep from 'lodash/cloneDeep';

export default class PermissionsController {
    $onChanges(changes) {
        if (changes.owner) {
            this.owner = _cloneDeep(changes.owner.currentValue);
        }

        if (changes.users) {
            this.users = _cloneDeep(changes.users.currentValue);
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/permissions/permissions.controller.js